// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ab82f16","455":"c2e3623d","977":"8df33b99"}[chunkId] + ".chunk.js";
};